import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { PortfolioDetailsItem } from "../../models/Portfolio";
import { LeoService } from "../../services/leoService";

export const setTab = createAction<number>('portfolioDetails/setTab');

export const setTimeline = createAction<number>('portfolioDetails/setTimeline');

export const loadPortfolioDetails = createAsyncThunk<PortfolioDetailsItem, string>(
    'portfolioDetails/loadPortfolioDetails',
    async (id) => {
        const leoService = new LeoService();
        return await leoService.GetPortfolioDetails(id);
    });